module.exports = `${require.publicPath}YouSheBiaoTiHei.1726685c.ttf`;